import { createContext } from 'react'

export const EventContext = createContext({
  eventId: null,
  changeEventId: () => {}
})

export const ReadOnlyContext = createContext(false)

export const CalculationContext = createContext({})



// WEBPACK FOOTER //
// ./src/context.js